import type { FaireThemeEntity } from "../../entity_types/theme";

export const boho_vintage_accents: FaireThemeEntity = {
  token: "boho-vintage-accents",
  type: "theme",
  name: "Boho-Vintage Accents",
  description: "Intricate knot designs and natural stone details that offer a vintage aesthetic with a modern finish. These pieces add a unique, soulful touch to any jewelry collection.",
  teaser: "Given the retailer's location in California and their clothing store prediction, these bohemian and vintage styles align perfectly with the relaxed yet sophisticated West Coast fashion vibe.",
  detail: "The payload includes the Sabine Multi Stone Statement Ring and the Virelle Vintage Knot Ring, both of which are explicitly categorized under bohemian and vintage styles in their attributes.",
  bgColor: "#D4E8E8",
  tileBgColor: "#6b4631",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_ufjavmwa64",
    "p_ut3tbs6mrw",
    "p_5vp5kwc33v",
    "p_7aj8n8fwkr",
    "p_skta3sqaky",
    "p_acjh7nsnea",
    "p_79hj62vt6k",
    "p_aqmjevz36r",
    "p_8kq2fhrkk2",
    "p_236hhz5fwt",
    "p_syptnc85d8",
    "p_vegvkzmg3j",
    "p_phz9z22vvv",
    "p_722ywtx5b8",
    "p_ubz7b6bcp2",
    "p_8gny2cq9wd",
    "p_cw59vqvskq",
    "p_7vjhdjw7rj",
    "p_4utebhvt2d",
    "p_7rqfbj75yg",
    "p_jp93mquugc",
    "p_tpf2apke3k",
    "p_z98zrpgyeh",
    "p_y3qwdbqxpg",
    "p_tx5bh7djqz",
    "p_pqf2f49nzz",
    "p_296y7ghmeu",
    "p_85zuvdfqvw",
    "p_jhcrb92fnq",
    "p_fnuyfkcfr3",
    "p_ezxwqwpffr",
    "p_zxurf3jtrh",
    "p_hdyjsgszee",
    "p_suye8v2z2s",
    "p_gqbd9wvwp7",
    "p_qmnrgkucxg",
    "p_psb59gs7zu",
    "p_zmtpk6urpp",
    "p_efa5ksyg38",
    "p_9dpr53wgyf",
    "p_v73v8ky4x6",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
